export abstract class CalendarDateValidator {
    public abstract isValid(date: Date): boolean;
}
